export const ConfigData = [
  {
    id: "name",
    name: "Name of Referee as per NRIC",
    isShow: true,
    width: "300px",
    filter: true,
  },
  {
    id: "nationality",
    name: "Nationality",
    isShow: true,
    width: "200px",
    filter: true,
  },
  {
    id: "contact_no",
    name: "Singapore Contact Number",
    isShow: true,
    width: "200px",
    filter: true,
  },
  {
    id: "position",
    name: "Position Applying",
    isShow: true,
    width: "200px",
    filter: true,
  },

  {
    id: "created_on",
    name: "Submitted Date Time",
    isShow: true,
    width: "200px",
    filter: false,
    format: "date-time",
  },
  {
    id: "status",
    name: "Status",
    isShow: true,
    width: "120px",
    filter: true,
  },
  {
    id: "button",
    name: "Action",
    type: "dropdown",
    isShow: true,
    width: "117px",
    action: ["Update Status", "View Details"],
     permission: {
      ["View Details"]: {
        id: "View Details",
        permission: ["hr_connect.access_staff_referral"]
      },
      ["Update Status"]: {
        id: "Update Status",
        permission: ["hr_connect.update_status_staff_referral"],
      },
    },
    isshowAction: {
      item: "status",
      children: [
        {
          id: "Update Status",
          value: "Update Status",
          notShowCondition: 'Not Suitable',
        },
        {
          id: "Update Status",
          value: "Update Status",
          notShowCondition: 'Completed',
        },
        {
          id: "Update Status",
          value: "Update Status",
          notShowCondition: 'Withdraw',
        }
      ],
    },
  },
];

export const dropdownConfig = [];



export const allStatusConfig = [
  {
    id: "submitted",
    name: "Submitted",
  },
  {
    id: "shortlistedforinterview",
    name: "Shortlisted for Interview",
  },
  {
    id: "offered&accepted",
    name: "Offered & Accepted",
  },
  {
    id: "completed",
    name: "Completed",
  },
  {
    id: "withdraw",
    name: "Withdraw",
  },
  {
    id: "notsuitable",
    name: "Not Suitable",
  },
];

export const DefaulSorting = {
  id: "created_on",
  name: "Created On",
  isShow: true,
  width: "160px",
  filter: true,
};